module.exports = __webpack_public_path__ + "static/media/Cross bite9.6f7b65f9.png";